<template>
    <div class="searchTabDiv lcpCard">
        <div class="inner">
			<span class="filterTitle">Search Results</span>
			<span class="icon-x" title="close search results" @click="closeSearch"></span>
			<div class="underline"><div class="underlineColour"></div></div>
			<div class="slideWrapper">
				<div class="filterDiv">
					<div class="detailsWrapper" v-for="(result, key) in searchResults" :key="`${result.Ticker}-${key}`">
						<span class="icon-star" :class="{activePinned: pinned(result.Ticker)}" @click="togglePinned(result.Ticker)">
						</span>
						<div class="managerTitle" :title="result.Name">{{result.Name}}</div>
					</div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            mainHeight: 0,
            filterArray: [],
        };
    },
    computed: {
        searchResults () {
            function sorting (a, b) {
                const fundNameA = a.Name.toLowerCase();
                const fundNameB = b.Name.toLowerCase();
                let comp = 0;

                if (fundNameA > fundNameB) {
                    comp = 1;
                } else if (fundNameA < fundNameB) {
                    comp = -1;
                }
                return comp;
            }
            if (this.$store.state.searchCriteria !== '') {
                return this.$store.state.universe.data.allMetaData.filter(result => result.Name.toLowerCase().includes(this.$store.state.searchCriteria.toLowerCase()));
            }
            return this.$store.state.universe.data.allMetaData.slice(0).sort(sorting);
        },
    },
    methods: {
        closeSearch () {
            this.$store.commit('closeSearch');
        },
        sectorColour (fund) {
            const sectorName = fund.Category;
            const sectorIndex = this.$store.state.universe.data.categoryDimensions[0].order.indexOf(sectorName);
            return this.$store.state.universe.data.categoryDimensions[0].colors[sectorIndex];
        },
        togglePinned (Ticker) {
            const result = this.$store.state.user.pinnedFunds.findIndex(i => i === Ticker);
            if (result > -1) {
                this.$store.commit('user/removePinnedFund', result);
            } else {
                this.$store.commit('user/addPinnedFund', Ticker);
            }
        },
        pinned (Ticker) {
            return this.$store.state.user.pinnedFunds.findIndex(i => i === Ticker) > -1;
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/all.scss';
.searchTabDiv{
    padding:20px;
    overflow: hidden;
    height: 80vh;
    position: relative;
    .filterTitle{
        float: left;
        font-size: 18px;
        cursor: pointer;
    }
    .dimensionsTitle{
        float: right;
        font-size: 18px;
        cursor: pointer;
    }
    .underline{
        height: 2px;
        width: 100%;
        background-color: $grey;
        float: left;
        margin: 5px 0 0 0;
        position: relative;
        .underlineColour{
            height: 3px;
            width: 30%;
            background: $darkBlue;
            position: absolute;
            top: 0px;
            left:0;
            @include easeInOut(1.0s);
            &.right{
                left:70%;
            }
        }
    }
    .icon-x{
        float: right;
        font-size: 22px;
        color: $grey;
        cursor: pointer;
    }
    .inner{
        overflow: hidden;
        margin-top:0;
        @include easeInOut(0.5s);
        position: absolute;
        top: 20px;
        bottom: 20px;
        left: 20px;
        right: 20px;
        &.slideUp{
            margin-top: -56px;
            min-height: 570px;
        }
    }
    .slideWrapper{
        float: left;
        width: 100%!important;
        left:0;
        overflow: auto;
        position: relative;
        @include easeInOut(1.0s);
        margin-top: 20px;
        height: calc(100% - 60px);
        .filterDiv, .dimensionsDiv{
            width: 100%;
            position: absolute;
            height: 100%;
        }
        .filterDiv{
            left: 0;
        }
    }
.detailsWrapper{
	cursor: pointer;
	display: flex;
	justify-content: flex-start;
	.activePinned {
		color: $LCPGrapefruit;
	}
    .managerTitle {
		width: 100%;
		text-align: left;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		font-weight: 700;
		margin-top: 0px;
		margin-left: 10px;
		margin-bottom: 0px;
		font-size: 16px;
	}
}


}

</style>
